import messages from './messages';

export const FulfillmentStrategyClosest = 'Closest';
export const FulfillmentStrategyFewestShipments = 'FewestShipments';

export const fulfillmentStrategies = [
  {
    id: FulfillmentStrategyClosest,
    message: messages.fulfillmentPriorityClosest,
    title: messages.fulfillmentPriorityClosestLabel,
  },
  {
    id: FulfillmentStrategyFewestShipments,
    message: messages.fulfillmentPriorityFewestShipments,
    title: messages.fulfillmentPriorityFewestShipmentsLabel,
  },
];
